var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card",style:({height:'600px',width:'100%'}),attrs:{"shadow":"never"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('div',{style:({height:'500px',width:'100%'}),attrs:{"id":"chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }